import React from 'react';

const RedirectToRegisterModal = ({ isOpen, onClose, onLoginClick }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Full-site overlay - click outside to close */}
      <div 
        className="fixed inset-0 bg-black/50 z-[60]" 
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 pointer-events-none">
        <div className="bg-white rounded-xl p-6 max-w-md w-full shadow-2xl relative pointer-events-auto">
          {/* Orange X Button (top right) - matches site theme */}
          <button
            onClick={onClose}
            className="absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center text-white font-bold cursor-pointer transition-all duration-200 hover:scale-110"
            style={{
              background: 'linear-gradient(135deg, #f59e0b, #f97316)',
              boxShadow: '0 3px 10px rgba(245, 158, 11, 0.4)',
            }}
            onMouseOver={(e) => e.currentTarget.style.background = 'linear-gradient(135deg, #f97316, #f59e0b)'}
            onMouseOut={(e) => e.currentTarget.style.background = 'linear-gradient(135deg, #f59e0b, #f97316)'}
          >
            ×
          </button>

          {/* Icon */}
          <div className="text-center mb-4">
            <div className="inline-flex items-center justify-center mb-4">
              <svg className="w-16 h-16" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="32" r="30" fill="#d1fae5" stroke="#10B981" strokeWidth="3"/>
                <image href="/icons/paw-frameless-64.png" x="12" y="12" width="40" height="40" />
              </svg>
            </div>
          </div>

          {/* Message */}
          <div className="text-center mb-6">
            <p className="text-gray-700 text-base mb-4 leading-relaxed">
              Adding, rating and commenting on locations requires you to log in.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed">
              Registration is quick and simple, please select from below to register
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col space-y-3">
            {/* Login/Register Button - Emerald Green */}
            <button
              onClick={onLoginClick}
              className="bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white py-3 px-6 rounded-full font-semibold shadow-lg transition-all duration-300 transform hover:scale-105"
            >
              Login / Register
            </button>

            {/* Close Window Button - Amber */}
            <button
              onClick={onClose}
              className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white py-3 px-6 rounded-full font-semibold shadow-lg transition-all duration-300 transform hover:scale-105"
            >
              Close Window
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedirectToRegisterModal;
